import { TTV_LAUNCH_AFFILIATES } from "@/features/ttv/launchAccess/constants";

export const getTtvLaunchAffiliate = (query: unknown): string | null => {
  if (typeof query !== "string") {
    return null;
  }
  const parameters = new URLSearchParams(query);
  for (const [parameter, references] of Object.entries(TTV_LAUNCH_AFFILIATES)) {
    const matches = parameters.getAll(parameter);
    if (matches.length === 1 && references.includes(matches[0])) {
      return new URLSearchParams({ [parameter]: matches[0] }).toString();
    }
  }
  return null;
};
